import { URLExtraParams } from '../typings';

import Ajax from '../lib/ajax';
import appendURLParams from '../helpers/append-url-parameters';
import { setLoadingIndicator, removeLoadingIndicator } from '../forms/loading-indicator';
import appendScripts from '../lib/append-scripts';

export default function postReopenAccountForm(element: string): boolean {
    const form: HTMLFormElement | null = document.querySelector(element);
    const isModal = !!document.querySelector('.modal--login');
    const urlExtraParams: URLExtraParams = { partial: 1 };
    const extraHeaders = { 'CC-Redirect-Assist': 'yes' };

    form?.addEventListener('submit', function (this: HTMLFormElement, e: Event) {
        if (!isModal) {
            return;
        }

        const action: string | null = this.getAttribute('action');

        setLoadingIndicator(this);

        if (!action) {
            return;
        }

        e.preventDefault();

        const url: string = appendURLParams(action, urlExtraParams);
        const data: FormData = new FormData(this);
        const request: Ajax = new Ajax();

        request
            .postFormData(url, data, extraHeaders)
            .then((response: Response) => {
                if (response.redirected) {
                    window.location.href = response.url;

                    return '';
                } else {
                    removeLoadingIndicator(this);

                    return response.text();
                }
            })
            .then((body: string) => {
                const loginWrapper: HTMLDivElement | null = document.querySelector('.js-login-wrapper');
                if (body && loginWrapper) {
                    loginWrapper.innerHTML = body;
                    appendScripts(loginWrapper);
                }
            });
    });

    return false;
}
